import type { Resource } from '../../';
export const forms_requiredIndicator: Resource = {"default":"* "};
